import PeopleListPage from "@/pages/PeopleListPage";
export default function CNAsPage() {
  return <PeopleListPage endpoint="cnas" title="CNAs" subtitle="On-site clinical nursing assistants." kindLabel="CNA" />;
}
